import React from 'react';

interface PatternLinkProps {
    patternId: number;
    patternName: string;
    areaId: number;         // Current area context (required for filtering)
    onClick?: (patternId: number, areaId: number) => void;
    style?: React.CSSProperties;
}

/**
 * Reusable component for rendering pattern names as clickable links
 * When clicked, navigates to a report template filtered by pattern + area type
 * Similar to MetricLink and AreaLink but for patterns
 */
export const PatternLink: React.FC<PatternLinkProps> = ({ 
    patternId, 
    patternName, 
    areaId,
    onClick, 
    style 
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(patternId, areaId);
        }
    };

    return (
        <a
            href="#"
            onClick={handleClick}
            style={{
                color: '#722ed1',  // Purple color for patterns (vs blue for areas, green for metrics)
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 500,
                ...style,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
            title={`View ${patternName} reports for this area`}
        >
            {patternName}
        </a>
    );
};

export default PatternLink;
